import AudienceStep from './AudienceStep';
import { LAST_STEP, STEPS } from './campaignWizardState';
import MessageStep from './MessageStep';
import RecipientsStep from './RecipientsStep';
import SendStep from './SendStep';
import useCampaignWizard from './useCampaignWizard';

const STEP_COMPONENTS = [AudienceStep, RecipientsStep, MessageStep, SendStep];

/**
 * Four steps to a WhatsApp campaign: audience, recipients, message, send. Going back keeps
 * everything entered. `onSent(campaignId)` is called once the campaign has been started.
 * @param {{onSent?: (campaignId: string) => void}} props
 */
const NewCampaignWizard = ({ onSent }) => {
  const wizard = useCampaignWizard({ onSent });
  const { state, problem, canContinue, next, back, draft } = wizard;
  const Step = STEP_COMPONENTS[state.step];

  return (
    <div className="space-y-5">
      <ol aria-label="Steps" className="flex gap-2 overflow-x-auto pb-1">
        {STEPS.map((label, index) => (
          <li
            key={label}
            aria-current={index === state.step ? 'step' : undefined}
            className={`flex items-center gap-2 px-3 py-1 text-sm whitespace-nowrap rounded-full border ${
              index === state.step
                ? 'bg-primary text-primary-foreground border-foreground'
                : index < state.step
                  ? 'text-foreground border-muted-foreground/50'
                  : 'text-muted-foreground border-border'
            }`}
          >
            <span aria-hidden="true">{index + 1}</span>
            {label}
          </li>
        ))}
      </ol>

      <div className="p-4 bg-card border border-border rounded-lg sm:p-6">
        <Step wizard={wizard} />
      </div>

      <div className="flex flex-wrap items-center gap-3">
        {state.step > 0 && (
          <button
            type="button"
            onClick={back}
            disabled={draft.testing || draft.sending}
            className="px-4 py-2 text-sm border border-input rounded-lg hover:bg-muted/50 disabled:opacity-50"
          >
            Back
          </button>
        )}
        {state.step < LAST_STEP && (
          <button
            type="button"
            onClick={next}
            disabled={!canContinue}
            className="px-5 py-2 text-sm text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 disabled:opacity-50"
          >
            Continue
          </button>
        )}
        {problem && <p className="text-sm text-muted-foreground min-w-0 break-words">{problem}</p>}
      </div>
    </div>
  );
};

export default NewCampaignWizard;
